<template>
  <div class="breadcrumb" :class="{ business: conf_2 }">
    <div class="breadcrumb__inner container flex a_center wc-lg">
      <router-link :to="get_main_page">
        <span class="f-14 regular"
          >{{ $fn.tr("Breadcrumb - Main Page") }}
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="4.5"
          height="7.582"
          viewBox="0 0 4.5 7.582"
        >
          <path
            id="Combined_Shape_Copy_2"
            data-name="Combined Shape Copy 2"
            d="M.13,6.253a.433.433,0,0,0,0,.619.449.449,0,0,0,.629,0L3.87,3.809a.433.433,0,0,0,0-.619L.759.128a.449.449,0,0,0-.629,0,.433.433,0,0,0,0,.619L2.927,3.5Z"
            transform="translate(0.25 0.291)"
            fill="#6d6e70"
            stroke="#fff"
            stroke-miterlimit="10"
            stroke-width="0.5"
          />
        </svg>
      </router-link>
      <router-link
        :to="link.full_url"
        v-for="(link, index) in get_menu"
        :key="index"
      >
        <span class="f-14 regular">
          {{
            $route.name == "PageViewRouter_ge"
              ? link.titles.ge.title
              : link.titles.en.title
          }}
        </span>
        <svg
          v-if="index !== get_menu.length - 1"
          xmlns="http://www.w3.org/2000/svg"
          width="4.5"
          height="7.582"
          viewBox="0 0 4.5 7.582"
        >
          <path
            id="Combined_Shape_Copy_2"
            data-name="Combined Shape Copy 2"
            d="M.13,6.253a.433.433,0,0,0,0,.619.449.449,0,0,0,.629,0L3.87,3.809a.433.433,0,0,0,0-.619L.759.128a.449.449,0,0,0-.629,0,.433.433,0,0,0,0,.619L2.927,3.5Z"
            transform="translate(0.25 0.291)"
            fill="#6d6e70"
            stroke="#fff"
            stroke-miterlimit="10"
            stroke-width="0.5"
          />
        </svg>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: ["contentData"],

  computed: {
    get_menu() {
      let menu = this.$store.state.main.indx.menus;
      let curr_menu = this.$store.state.main.selected_menu;

      menu = menu.filter(
        m =>
          (m.configs.includes("breadcrumb") &&
            m.set_home !== 1 &&
            m.id == curr_menu.pid) ||
          (m.configs.includes("breadcrumb") &&
            m.set_home !== 1 &&
            m.id == curr_menu.id)
      );
      let first_url = menu.find(m => m.id === curr_menu.pid);
      let first_url_idx = menu.indexOf(first_url);

      let first_url_removed = menu.splice(first_url_idx, 1);
      menu.splice(0, 0, first_url_removed[0]);
      return menu;
    },
    conf_2() {
      let conf = _.get(this.contentData, "conf.conf");
      if (conf) {
        conf = conf.filter(cf => cf == "business");
        return conf[0];
      }
    },
    get_main_page() {
      let menu = this.$store.state.main.indx.menus;
      menu = menu.filter(m => m.set_home == 1);
      return menu[0].full_url;
    }
  }
};
</script>
